import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface IState extends IDefaultState<any, any, any> {
  entitiesBillingSelect: any[];
  entitiesBillingSelectLoading: boolean;
}

const reducers = {
  ...defaultReducers,
  setItemsSelectLoading: (state:any, action:PayloadAction<boolean>) => {
    state.entitiesSelectLoading = action.payload;
  },
  setItemsSelect: (state:any, action:PayloadAction<any[]>) => {
    state.entitiesSelect = action.payload;
  },
  setItemsBillingSelectLoading: (state:any, action:PayloadAction<boolean>) => {
    state.entitiesBillingSelectLoading = action.payload;
  },
  setItemsBillingSelect: (state:any, action:PayloadAction) => {
    state.entitiesBillingSelect = action.payload
  }
};

const initialState:IState = {
  ...defaultInitialState,
  entitiesBillingSelect: [],
  entitiesBillingSelectLoading: false,
};

export const regionsSlice = createSlice({
  name: "regions",
  initialState,
  reducers,
});
